import { Box, Stack } from '@mantine/core'
import {
  createFileRoute,
  Outlet,
  useNavigate,
  useRouterState,
} from '@tanstack/react-router'
import { useLayoutEffect } from 'react'
import type { BoggleGameModeId } from '~/boggle/gameModes'
import { GamePageHeader } from '~/boggle/ui/chrome/AppLayout'
import { GameModeCatalogScreen } from '~/boggle/ui/screens/GameModeCatalogScreen'
import { useBoggleModeSession } from '~/boggle/ui/state/ModeSession'

export const Route = createFileRoute('/games')({
  head: () => ({
    meta: [
      { title: 'Games — Patter' },
      {
        name: 'description',
        content: 'Choose a game to play',
      },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
  component: GamesRoute,
})

function GamesRoute() {
  const navigate = useNavigate()
  const { clearRouteHostedGameMode, endStandardRun } = useBoggleModeSession()
  const pathname = useRouterState({
    select: state => state.location.pathname,
  })

  const isGamesIndex = pathname === '/games' || pathname === '/games/'

  useLayoutEffect(() => {
    if (!isGamesIndex) {
      return
    }

    // Leaving `/games/$gameModeId` via browser Back can restore this route while
    // `isStandardRunActive` is still true; clear it so `/` is not a "phantom" run.
    endStandardRun()
    clearRouteHostedGameMode()
  }, [clearRouteHostedGameMode, endStandardRun, isGamesIndex])

  if (!isGamesIndex) {
    return <Outlet />
  }

  return (
    <Stack gap={0} h="100%" mih={0}>
      <GamePageHeader />
      <Box flex={1} mih={0}>
        <GameModeCatalogScreen
          onBack={() => {
            void navigate({ to: '/' })
          }}
          onSelect={(gameModeId: BoggleGameModeId) => {
            void navigate({
              to: '/games/$gameModeId',
              params: { gameModeId },
              state: { boggleAutoStartStandardRun: true },
            })
          }}
        />
      </Box>
    </Stack>
  )
}
